<!-- Sidebar mobile toggler -->
<div class="sidebar-mobile-toggler text-center">
    <a href="#" class="sidebar-mobile-main-toggle">
        <i class="icon-arrow-left8"></i>
    </a>
    Navigation
    <a href="#" class="sidebar-mobile-expand">
        <i class="icon-screen-full"></i>
        <i class="icon-screen-normal"></i>
    </a>
</div>
<!-- /sidebar mobile toggler -->
<!-- Sidebar content -->
<div class="sidebar-content">
    <!-- Main navigation -->
    <div class="card card-sidebar-mobile">
        <ul class="nav nav-sidebar" data-nav-type="accordion">
            <!-- Main -->
            <li class="nav-item-header"><div class="text-uppercase font-size-xs line-height-xs">Main</div> <i class="icon-menu" title="Main"></i></li>
            <!-- /main -->
            <!-- User Roles -->
            <li class="nav-item" *appCheckPermissions="['vehicle_live_details']">
                <a routerLink="/vehicle-live-status" class="nav-link" routerLinkActive="active">
                    <i class="icon-collaboration"></i>
                    <span>Vehicle Live Status</span>
                </a>
            </li>
            <!-- User Roles -->
            <li class="nav-item" *appCheckPermissions="['role_list']">
                <a routerLink="/roles" class="nav-link" routerLinkActive="active">
                    <i class="icon-collaboration"></i>
                    <span>User Roles</span>
                </a>
            </li>
            <li class="nav-item" *appCheckPermissions="['user_list']">
                <a routerLink="/users" class="nav-link" routerLinkActive="active">
                    <i class="icon-users4"></i>
                    <span>Users</span>
                </a>
            </li>
            <li class="nav-item" *appCheckPermissions="['device_list']">
                <a routerLink="/devices" class="nav-link" routerLinkActive="active">
                    <i class="icon-cube"></i>
                    <span>Devices</span>
                </a>
            </li>
            <li class="nav-item" *appCheckPermissions="['asset_list']">
                <a routerLink="/all-assets" class="nav-link" routerLinkActive="active">
                    <i class="icon-truck"></i>
                    <span>{{ _asset_label }}s</span>
                </a>
            </li>
            <li class="nav-item" *appCheckPermissions="['fuel_filling_list']">
                <a routerLink="/fuel-fillings" class="nav-link" routerLinkActive="active">
                    <i class="fa fa-flask"></i>
                    <span>Filling History</span>
                </a>
            </li>
            <li class="nav-item" *appCheckPermissions="['asset_group_list']">
                <a routerLink="/asset-groups" class="nav-link" routerLinkActive="active">
                    <i class="icon-make-group"></i><span>{{ _asset_label }} Groups</span>
                </a>
            </li>
            <li class="nav-item" *appCheckPermissions="['drivers_list']">
                <a routerLink="/drivers" class="nav-link" routerLinkActive="active">
                    <i class="icon-person"></i>
                    <span>Drivers</span>
                </a>
            </li>
            <li class="nav-item" *appCheckPermissions="['maintenance_list']">
                <a routerLink="/maintenance/index" class="nav-link" routerLinkActive="active">
                    <i class="icon-cogs"></i>
                    <span>Maintenance</span>
                </a>
            </li>
            <li class="nav-item" *appCheckPermissions="['maintenance_work_jobs_list']">
                <a routerLink="/maintenance-work-jobs" class="nav-link" routerLinkActive="active">
                    <i class="icon-person"></i>
                    <span>Work Jobs</span>
                </a>
            </li>
            <li class="nav-item" *appCheckPermissions="['poi_list']">
                <a routerLink="/poi/index" class="nav-link" routerLinkActive="active">
                    <i class="icon-touch"></i>
                    <span>Poi</span>
                </a>
            </li>
            <li class="nav-item" *appCheckPermissions="['zone_list']">
                <a routerLink="/zone/index" class="nav-link" routerLinkActive="active">
                    <i class="icon-multitouch"></i>
                    <span>Zone</span>
                </a>
            </li>
            <li class="nav-item" *appCheckPermissions="['routes_list']">
                <a routerLink="/routes" class="nav-link" routerLinkActive="active">
                    <i class="icon-tree7"></i>
                    <span>Routes</span>
                </a>
            </li>
            <li class="nav-item" *appCheckPermissions="['trip_list']">
                <a routerLink="/trips" class="nav-link" routerLinkActive="active">
                    <i class="icon-road"></i>
                    <span>Trips</span>
                </a>
            </li>
            <li class="nav-item" *appCheckPermissions="['mapping_key_list']">
                <a routerLink="/mapping-keys" class="nav-link" routerLinkActive="active">
                    <i class="icon-key"></i>
                    <span>Keys</span>
                </a>
            </li>
            <li class="nav-item" *appCheckPermissions="['alert_list']">
                <a routerLink="/alerts" class="nav-link" routerLinkActive="active">
                    <i class="icon-alert"></i>
                    <span>Alerts</span>
                </a>
            </li>
            <li class="nav-item" *appCheckPermissions="['events_list']">
                <a routerLink="/events" class="nav-link" routerLinkActive="active">
                    <i class="icon-warning"></i>
                    <span>Events</span>
                </a>
            </li>
            <li class="nav-item" *appCheckPermissions="['report_generate_vehicle_event_report']">
                <a routerLink="/vehicle-events" class="nav-link" routerLinkActive="active">
                    <i class="icon-warning"></i>
                    <span>Alerts</span>
                </a>
            </li>
            <li class="nav-item" *appCheckPermissions="['generate_reports']">
                <a routerLink="/reports" class="nav-link" routerLinkActive="active" *ngIf="!_is_wssp">
                    <i class="icon-copy"></i>
                    <span>Reports</span>
                </a>
            </li>
            <!--<li class="nav-item" *appCheckPermissions="['fuel-filling-reports']">
                <a routerLink="/report/fuel-filling" class="nav-link" routerLinkActive="active">
                    <i class="icon-report"></i>
                    <span>Fuel Filling Reports</span>
                </a>
            </li>-->
            <li class="nav-item">
                <a routerLink="/tracker/index" class="nav-link" routerLinkActive="active" *appCheckPermissions="['tracker_list']">
                    <i class="icon-lifebuoy"></i>
                    <span>Tracker</span>
                </a>
            </li>
            <li class="nav-item" *appCheckPermissions="['report_generate_history']">
                <a routerLink="/general-reports" class="nav-link" routerLinkActive="active">
                    <i class="icon-copy"></i>
                    <span>General Reports</span>
                </a>
            </li>
        </ul>
    </div>
    <!-- /main navigation -->
</div>
<!-- /sidebar content -->
